<template>
    <div class="sheetBatchExportModal">
        <dsh-modal
            class="sheetBatchExportModal-modal"
            v-model="showModal"
            :mode="modalPropsObj.mode"
            :propsObj="modalPropsObj"
        >
            <div class="sheetBatchExportModal-wrap">
                <div class="sheetBatchExportModal-header">
                    <Checkbox
                        class="sheetBatchExportModal-header-selectAll"
                        v-model="isSelectAll"
                    >全选</Checkbox>

                    <Button
                        class="sheetBatchExportModal-header-btn"
                        type="info"
                        icon="md-export"
                        shape="circle"
                        :disabled="!selectKeys.length"
                        :loading="btnLoading"
                        @click="handleExport()"
                    >导出</Button>
                </div>

                <div class="sheetBatchExportModal-content">
                    <CheckboxGroup v-model="selectKeys">
                        <Row>
                            <Col
                                v-for="item in listData"
                                :key="item._key"
                                class="sheetBatchExportModal-content-item"
                                span="6"
                            >
                            <Checkbox :label="item._key">{{ item._name }}</Checkbox>
                            </Col>
                        </Row>
                    </CheckboxGroup>
                </div>
            </div>
        </dsh-modal>
    </div>
</template>

<script>
    export default {
        name: "sheetBatchExportModal",
        components: {},
        props: {
            value: Boolean,

            companyId: String,
            appId: String,
            modKey: String,
            screenKey: String,
            // dataIds: {
            //     type: Array,
            //     default () {
            //         return [];
            //     }
            // },
            formList: {
                type: Array,
                default () {
                    return [];
                }
            },
            exportParams: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                modalPropsObj: {
                    mode: "middle",
                    title: "将选择的视图数据导出为 Excel",
                    width: "960",
                    className: "vertical-center-modal",
                    maskClosable: false,
                    footerHide: true
                },

                urlParams: {
                    module: "sheet"
                },
                // 导出数据
                modalLoading: false,
                btnLoading: false,
                fieldBatchExportMap: this.$getModFieldPropertyMap("canBatchExport"),
                selectData: [],
                timer: null
            };
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit("input", val);
                }
            },
            listData () {
                return [
                    {
                        _key: "_id",
                        _name: "id"
                    }
                ].concat(
                    this.formList
                        .filter(item => this.fieldBatchExportMap[item._type])
                        .map(item =>
                            ({
                                _key: item._key,
                                _name: item._name
                            })
                        )
                );
            },

            isSelectAll: {
                get () {
                    return this.listData.length > 0 && this.selectKeys.length === this.listData.length;
                },
                set (bool) {
                    this.selectData = bool ? this.listData : [];
                }
            },
            selectKeys: {
                get () {
                    return this.selectData.map(item => item._key);
                },
                set (val) {
                    this.selectData = this.listData.filter(item => val.includes(item._key));
                }
            }
        },
        created () {},
        methods: {
            // 接口 -导出
            handleExport () {
                this.btnLoading = true;

                this.$https({
                    url: {
                        ...this.urlParams,
                        name: "exportExcel"
                    },
                    params: {
                        fields: this.selectKeys,
                        screenKey: this.screenKey,
                        ...this.exportParams
                    },
                    callback: data => {
                        this.showModal = false;
                        this.btnLoading = false;
                        this.selectData = [];

                        this.timer = setInterval(() => {
                            this.getJobStatus(data.jobId);
                        }, 1000);
                    },
                    error: response => {
                        this.btnLoading = false;
                        clearInterval(this.timer);
                        this.$Message.error({
                            content: "操作失败！" + response.msg,
                            duration: 5
                        });
                    }
                });
            },
            // 接口 -导出链接
            getJobStatus (id) {
                this.$https({
                    url: {
                        ...this.urlParams,
                        name: "getJobStatus"
                    },
                    params: {
                        jobId: id
                    },
                    callback: data => {
                        if (data.status === "completed") {
                            clearInterval(this.timer);
                            window.location.href = data.url;
                        } else if (data.status === "failed") {
                            clearInterval(this.timer);
                            this.$Message.info({ content: "操作失败，请稍后再试" });
                        }
                    },
                    error: data => {
                        this.timer = null;
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/operation/sheetBatchExportModal.vue